import './PlayerHeaderTabNg.less';

import React from 'react';
import clsx from 'clsx';
import { dispatch } from 'nike-re-framejs';
import { setBeradarPlayerActiveTab } from '@/src/infocentrum/handlers';
import { startVideo } from '@/src/player/player-actions';
import { VIDEO } from '@/src/player/services/tabConstants';

export const PlayerHeaderTabNg = ({ name, match, isEnabled, title, isActive, 'data-atid': dataAtid, children }) => {
    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        if (isEnabled) {
            dispatch(setBeradarPlayerActiveTab(name));
            if (name === VIDEO) startVideo(match?.get('id'), null);
        }
    };
    return (
        <button
            className={clsx('player-header-tab flex-center px-10 fs-14', {
                'bg-orange': isActive && isEnabled,
                'player-header-tab-inactive': !isActive || !isEnabled,
                disabled: !isEnabled
            })}
            title={title}
            onClick={handleClick}
            data-atid={dataAtid}
        >
            {children}
        </button>
    );
};
